
  import { computed, defineComponent, inject, ref, Ref } from 'vue';
  import { analyticsPermissions, hasSomePermission } from '@/ui/auth/auth';
  import { ForbiddenPage } from '@/ui/pages/error/ForbiddenPage';
  import { useDetailedViewStore } from '@/stores/analytics/detailedView';
  import { pushRoute } from '@/ui/helpers';
  import { PageTitle } from '@/ui/components/PageTitle';
  import Level from '@/ui/components/common/Level.vue';
  import SubmittedFormDetailedView from '@/ui/components/analytics/detailedView/SubmittedFormDetailedView.vue';
  import ActionDetailedView from '@/ui/components/analytics/detailedView/ActionDetailedView.vue';
  import ScheduledFormDetailedView from '@/ui/components/analytics/detailedView/ScheduledFormDetailedView.vue';
  import { ReportRecordData } from '@/services/api/resources/analytics-builder/model';
  import { reportFromAnalyticsPageKey } from '@/ui/injectionKeys';
  import { useDetailedView } from '@/ui/concerns/analytics/useDetailedView';
  import FormItemDetailedView from '@/ui/components/analytics/detailedView/FormItemDetailedView.vue';

  export default defineComponent({
    components: {
      Level,
      PageTitle,
      ForbiddenPage,
      SubmittedFormDetailedView,
      ActionDetailedView,
      ScheduledFormDetailedView,
    },
    setup(_, context) {
      const store = useDetailedViewStore();
      const { getDetailedViewTitle } = useDetailedView();
      const report = inject<Ref<ReportRecordData | null>>(reportFromAnalyticsPageKey, ref(null));
      const widget = computed(() => report.value?.widgets.find(widget => widget.key === store.widgetKey));

      if (!(store.isValid && widget.value)) {
        pushRoute({ name: 'analytics-v2' });
      }

      const onBack = () => context.emit('detailed-view-close');

      const canAccessDetailedView = hasSomePermission(analyticsPermissions);

      const pageTitleText = widget.value
        ? getDetailedViewTitle(store.detailedViewType, store.options.head ?? '', widget.value)
        : '';

      const view = () => {
        switch (store.detailedViewType) {
          case 'submitted-forms':
            return SubmittedFormDetailedView;
          case 'actions':
            return ActionDetailedView;
          case 'schedule-forms':
            return ScheduledFormDetailedView;
          case 'form-items':
          case 'negative-responses':
            return FormItemDetailedView;
          default:
            return null;
        }
      };

      return {
        canAccessDetailedView,
        pageTitleText,
        onBack,
        view,
      };
    },
  });
